module.exports = __webpack_public_path__ + "icon_cube_bunch.186ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_cube_bunch.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_cube_bunch.svg
// module chunks = main